import { Link } from "react-router-dom";
import Img1 from "../../assets/img/about-us/about-1.png";
import Img2 from "../../assets/img/about-us/about-2.png";

import Layout from "../../components/layout/Layout";
// import GetInTouch from "./GetInTouch";
// import OurTeam from "./OurTeam";
// import WorkingProcess from "./WorkingProcess";

const About = () => {
  return (
    <Layout>
      <h1>
        About
      </h1>
    </Layout>
  );
};

export default About;
